function RemergeLogo() {
  return (
    <svg
      viewBox="0 0 2292 2292"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      stroke="currentColor"
      width="48"
      height="48"
    >
      <g>
        <g id="Layer_1">
          <circle fill="#d2c8ff" cx="1145.5" cy="1146" r="1146" />
          <path d="M840.3,599.7c-127.5,0-199.8,56.8-236,175.7v.6h-137.8v930h137.8v-620.5c0-205,50-363.5,225.7-363.5h246.8v984h137.8v-706.6c0-168.8,106.8-287.7,255-287.7s217.1,99.9,217.1,248.1v746.2h137.8v-768.6c0-211.9-127.5-351.5-323.9-351.5s-241.2,60.3-286,180.9h-5.9v-167.1h-368.4Z" />
        </g>
      </g>
    </svg>
  );
}
export default RemergeLogo;
